import * as React from 'react';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ObjectTypeLabel from 'flow-doctor-lib/components/common/ObjectTypeLabel';
import UnifiedEventPropertyTable from 'flow-doctor-lib/components/timeline/labels/UnifiedEventPropertyTable';
import { useEventProperties } from 'flow-doctor-lib/hooks/useEventProperties';
import { getIsPropertyChangedEvent, getObjectTypeIdFromObject } from 'flow-doctor-lib/utils/eventFilterUtils';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import PropertyChangeEventPropertyTable from 'flow-doctor-lib/components/timeline/PropertyChangeEventPropertyTable';
import EnrollmentChecksButton from 'flow-doctor-lib/components/timeline/EnrollmentChecksButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnifiedEventTimelineItemLabel = ({
  logItem
}) => {
  const {
    event
  } = logItem.data;
  const eventTypeId = getObjectTypeIdFromObject(event.eventTypeId);
  const associatedObjectTypeId = getObjectTypeIdFromObject(event.objectTypeId);
  const {
    eventProperties,
    eventPropertiesLoading,
    filteredEventProperties
  } = useEventProperties({
    event
  });
  if (eventPropertiesLoading) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(SkeletonText, {
          width: 200
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(SkeletonText, {
          width: 150
        })
      })]
    });
  }
  const numEventProperties = Object.keys(filteredEventProperties).length;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: getIsInternal() ? 'flow-doctor-lib.flows.objectLifecycle.unifiedEventHistory.labelInternal_jsx' : 'flow-doctor-lib.flows.objectLifecycle.unifiedEventHistory.labelExternal_jsx',
      elements: {
        b: 'b',
        ObjectTypeLabel
      },
      options: {
        portalId: event.portalId,
        objectTypeId: `${event.eventTypeId.metaTypeId}-${event.eventTypeId.innerId}`
      }
    }), numEventProperties > 0 ? /*#__PURE__*/_jsx(UIAccordionItem, {
      disabled: numEventProperties === 0,
      flush: true,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.objectLifecycle.unifiedEventHistory.viewDetails"
      }),
      children: getIsPropertyChangedEvent(eventTypeId) ? /*#__PURE__*/_jsx(PropertyChangeEventPropertyTable, {
        associatedObjectTypeId: associatedObjectTypeId,
        properties: filteredEventProperties,
        propertyDefinitions: eventProperties
      }) : /*#__PURE__*/_jsx(UnifiedEventPropertyTable, {
        properties: filteredEventProperties,
        propertyDefinitions: eventProperties
      })
    }) : /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.objectLifecycle.unifiedEventHistory.numEventProperties",
        options: {
          count: numEventProperties
        }
      })
    }), /*#__PURE__*/_jsx(EnrollmentChecksButton, {
      timelineItem: logItem
    })]
  });
};
export default UnifiedEventTimelineItemLabel;